// ---------------------------------------------- modules import
import { IUserState, UserAction, UserActionType } from "./common";

const initialState: IUserState = {
  loading: false,
  error: null
};

// ---------------------------------------------- the reducer
const userReducer = (state = initialState, action: UserAction): IUserState => {
  switch (action.type) {
    case UserActionType.ADD_USER_BEGIN:
    case UserActionType.UPDATE_USER_BEGIN:
    case UserActionType.DELETE_USER_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case UserActionType.ADD_USER_SUCCESS:
    case UserActionType.UPDATE_USER_SUCCESS:
    case UserActionType.DELETE_USER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      };
    }
    case UserActionType.ADD_USER_ERROR:
    case UserActionType.UPDATE_USER_ERROR:
    case UserActionType.DELETE_USER_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };
    }
    default: {
      return state;
    }
  }
};

export default userReducer;
